<div class="p-modal-body11">
  <!--
  /=====================================================
  アイテム横並びリストが画面幅より大きくなった場合はカルーセル機能となります。
  サンプルはカルーセル状態で設置しております。（画面内に収まる場合はl-carousel01__arrowのis-availableがない状態です）
  =====================================================/
  -->
  <div class="l-carousel01 l-carousel01--in-modal-body11" aria-label="カルーセルタイトル">
    <asw-block-slider [isButtonEnable]="true">
      <div class="p-modal-payment-detail-panel" #scrollPanel>
        <!-- [9.13]  購入サービス情報
      サービス別の購入情報を記載する。-->
        <ng-container *ngFor="let paymentDetail of paymentDetailsList; index as Idx">
          <div
            class="p-modal-payment-detail-panel__item"
            role="group"
            [attr.aria-label]="'slide ' + (Idx + 1) + ' of ' + paymentDetailsList.length"
          >
            <div class="p-modal-payment-detail-panel__head js-fix-height-1" #passengers>
              <dl class="c-float-list03">
                <div class="c-float-list03__item">
                  <dt
                    class="c-float-list03__title c-float-list03__title--em"
                    [innerHTML]="paymentDetail.passengerName"
                  ></dt>
                  <dd
                    class="c-float-list03__contents c-float-list03__contents--gray60 u-weight-normal"
                    [innerHTML]="getPassengerTypeLabel(paymentDetail.passengerType) | staticMsg"
                  ></dd>
                </div>
                <div
                  class="c-float-list03__item c-float-list03__item--mt0"
                  *ngIf="paymentDetail.accompanyingName; let name"
                >
                  <dt class="c-float-list03__title" [innerHTML]="name"></dt>
                  <dd
                    class="c-float-list03__contents c-float-list03__contents--gray60 u-weight-normal"
                    [innerHTML]="getPassengerTypeLabel('INF') | staticMsg"
                  ></dd>
                </div>
              </dl>
            </div>
            <div class="p-modal-payment-detail-panel__body">
              <dl class="c-def-list02">
                <div class="c-def-list02__item">
                  <dt class="c-def-list02__item-title" [innerHTML]="'label.paidService' | staticMsg"></dt>
                  <dd class="c-def-list02__item-body">
                    <dl class="c-float-list04">
                      <ng-container
                        *ngFor="let purchasedServiceInformation of paymentDetail.purchasedServiceInformationList"
                      >
                        <div [ngClass]="['c-float-list04__item']">
                          <dt
                            class="c-float-list04__title"
                            [innerHTML]="purchasedServiceInformation.purchaseServiceName ?? '' | staticMsg"
                          ></dt>
                          <dd class="c-float-list04__contents">
                            <span class="c-amount c-amount--price">
                              <span
                                class="c-amount__num"
                                [innerHTML]="getAmount(purchasedServiceInformation.amountByService)"
                              ></span>
                            </span>
                          </dd>
                        </div>
                      </ng-container>
                    </dl>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </ng-container>
      </div>
    </asw-block-slider>
  </div>
</div>
